import { render, staticRenderFns } from "./arrangement.vue?vue&type=template&id=bedb6b62&scoped=true&"
import script from "./arrangement.vue?vue&type=script&lang=js&"
export * from "./arrangement.vue?vue&type=script&lang=js&"
import style0 from "./arrangement.vue?vue&type=style&index=0&id=bedb6b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedb6b62",
  null
  
)

export default component.exports